import { _decorator } from 'cc';
import DropdownOption from './DropdownOption';
import MultiThemeSource from '../MultiTheme/MultiThemeSource';

const { ccclass, requireComponent } = _decorator;

@ccclass('MultiThemeDropdownOption')
@requireComponent(MultiThemeSource)
export default class MultiThemeDropdownOption extends DropdownOption {
    private _multiThemeSource: MultiThemeSource = null;

    private get multiThemeSource(): MultiThemeSource {
        if (!this._multiThemeSource) {
            this._multiThemeSource = this.getComponent(MultiThemeSource);
        }
        return this._multiThemeSource;
    }

    public onSelected(): void {
        this.multiThemeSource.theme = 1;
    }
    public onDeselected(): void {
        this.multiThemeSource.theme = 0;
    }
}
